var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#3F51B5","height":"70px","margin-top":"50px"}},[_c('h2',{staticClass:"white--text pt-4 ml-12 mr-12"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("Mesanalyses.dz")])])])}
var staticRenderFns = []

export { render, staticRenderFns }